define("calendar/components/calendar/provide-bttp", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/object", "@ember/service", "calendar/resources/bttp"], function (_exports, _component, _templateFactory, _component2, _tracking, _object, _service, _bttp) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/object",0,"@ember/service",0,"calendar/resources/bttp",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    {{did-update this.handleProfileChange this.socialProfileType}}
  />
  {{yield
    (hash
      isRunning=this.bttpReport.fetchTask.isRunning
      report=this.bttpReport.fetchTask.value
      shouldShow=this.shouldShowBttp
      toggledOn=this.bttpToggledOn
      toggle=this.toggleBttp
    )
  }}
  
  */
  {
    "id": "b52kTYP3",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"handleProfileChange\"]],[30,0,[\"socialProfileType\"]]],null],[12],[13],[1,\"\\n\"],[18,1,[[28,[37,2],null,[[\"isRunning\",\"report\",\"shouldShow\",\"toggledOn\",\"toggle\"],[[30,0,[\"bttpReport\",\"fetchTask\",\"isRunning\"]],[30,0,[\"bttpReport\",\"fetchTask\",\"value\"]],[30,0,[\"shouldShowBttp\"]],[30,0,[\"bttpToggledOn\"]],[30,0,[\"toggleBttp\"]]]]]]],[1,\"\\n\"]],[\"&default\"],false,[\"did-update\",\"yield\",\"hash\"]]",
    "moduleName": "calendar/components/calendar/provide-bttp.hbs",
    "isStrictMode": false
  });

  const TOGGLED_BTTP_SEGMENT_EVENT = 'toggled-best-time-to-post';
  const CACHE_KEY = 'showBttp';
  const TOGGLE_STATES = Object.freeze({
    ON: 'on',
    OFF: 'off'
  });
  let ProvideBttpComponent = (_class = class ProvideBttpComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "bttp", _descriptor2, this);

      _initializerDefineProperty(this, "cache", _descriptor3, this);

      _initializerDefineProperty(this, "segment", _descriptor4, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor5, this);

      _initializerDefineProperty(this, "bttpToggledOn", _descriptor6, this);

      _defineProperty(this, "bttpReport", _bttp.default.from(this, () => []));

      this.bttpToggledOn = this.cache.retrieve(this.toggleCacheKey) || false;
    }

    get shouldShowBttp() {
      return this.bttpToggledOn && this.bttp.canBttp && this.bttp.isValidSocialProfile && !this.selectedSocialProfiles.hasMultipleSelected;
    }

    get socialProfileType() {
      var _this$selectedSocialP;

      return (_this$selectedSocialP = this.selectedSocialProfiles.firstProfile) === null || _this$selectedSocialP === void 0 ? void 0 : _this$selectedSocialP.profileType;
    }

    get toggleCacheKey() {
      return "".concat(CACHE_KEY, "-").concat(this.socialProfileType);
    }

    handleProfileChange() {
      this.bttpToggledOn = this.cache.retrieve(this.toggleCacheKey) || false;
    }

    toggleBttp() {
      const {
        ON,
        OFF
      } = TOGGLE_STATES;
      this.bttpToggledOn = !this.bttpToggledOn;
      this.cache.add(this.toggleCacheKey, this.bttpToggledOn, {
        expiry: this.cache.maxExpiryDate(),
        persist: true
      });
      this.segment.track(TOGGLED_BTTP_SEGMENT_EVENT, {
        new_state: this.bttpToggledOn ? ON : OFF,
        social_profile_handle: this.selectedSocialProfiles.firstProfile.nickname
      });
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "bttpToggledOn", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "handleProfileChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleProfileChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleBttp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleBttp"), _class.prototype)), _class);
  _exports.default = ProvideBttpComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProvideBttpComponent);
});